import React from "react";
import cx from "classnames";

import Offcanvas from "react-bootstrap/Offcanvas";
import styles from "./slider.module.scss";

interface SliderInterface {
  className?: string;
  width: string;
  show: boolean;
  title?: string;
  onClose: () => void;
  children?: React.ReactNode;
  placement?: "start" | "end"; 
}

const SliderDialog: React.FC<SliderInterface> = ({ className, width, show, title, onClose, children, placement = "start" }) => {
  const handleClose = () => {
    if(onClose){
      onClose();
    }
  };

  const sliderStyle = {
    width: width
  };

  return (
    <Offcanvas
      backdropClassName={styles.sliderBackground}
      backdrop={'static'}
      className={cx(styles.slider, className)}
      style={sliderStyle}
      show={show}
      keyboard={false}
      autoFocus={false}
      enforceFocus={false}
      onHide={handleClose}
      placement={placement}
    >
      {title && <Slider.Header>{title}</Slider.Header>}
      <Offcanvas.Body>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

interface SliderHeaderProps {
  className?: string;
  children?: React.ReactNode;  
  title?: string | React.ReactNode;
  message?: string;
  icon? : string;
  handleClick?: () => void;
}

const SliderHeader: React.FC<SliderHeaderProps> = ({ className, title, message, children, icon, handleClick }) => {
  return <div className={cx(styles.header, className)}>
    {title && <h2 className={styles.title}>
      {icon && <i className={cx(`${icon}`, styles.icon)} onClick={handleClick}></i>}
      {title}</h2>
    }
    {message && <p className={styles.message}>{message}</p>}
    {children}
  </div>;
}

interface SliderBodyProps {
  className?: string;
  children?: React.ReactNode;  
}

const SliderBody: React.FC<SliderBodyProps> = ({ className, children }) => {
  return <div className={cx(styles.body, className)}>
    {children}
  </div>;
}

interface SliderActionsProps {
  children: React.ReactNode;
}

const SliderActions: React.FC<SliderActionsProps> = ({ children }) => {
  return <div className={styles.actions}>
    {children}
  </div>;
}

const Slider = {
  Dialog: SliderDialog,
  Header: SliderHeader,
  Body: SliderBody,
  Actions: SliderActions
};

export default Slider;